module.exports = __webpack_public_path__ + "static/Pattern-ac5b95df4f806f0c28a1f6f87f0a4fac.svg";